export const DEFAULT_MOBILE_BREAKPOINT = 765;
export const PATIENTS_LIST_MOBILE_MAX_WIDTH = DEFAULT_MOBILE_BREAKPOINT;



// WEBPACK FOOTER //
// ./src/sources/constants/screenSizes.js